import { render, staticRenderFns } from "./MCQPieCharts.vue?vue&type=template&id=b30fe1aa"
import script from "./MCQPieCharts.vue?vue&type=script&lang=js"
export * from "./MCQPieCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports